import { PortableText } from '@portabletext/react';

import { useTranslate } from '../../../../../../../../../../hooks/useTranslate';
import { Disclaimer, TermsAndConditions } from './Initial.styles';

export const Initial = () => {
  const { t, pt } = useTranslate();

  return (
    <>
      <PortableText value={pt('explore.amelia.initialMessage')} />

      <Disclaimer>{t('explore.amelia.disclaimer')}</Disclaimer>

      <TermsAndConditions target="_blank" href="/privacy-policy">
        {t('explore.amelia.termsAndConditions')}
      </TermsAndConditions>
    </>
  );
};
